import { Modal } from "react-bootstrap";
import Button from "../../../components/common/Button";

const SavedModal = ({show = false, handleClose = {}}) => {
    return(
        <Modal show={show} id="savedModal" centered tabIndex={-1}>
            <Modal.Header>
                <h5 className="modal-title">
                    Your work has been saved
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                    aria-label="Close"
                />
            </Modal.Header>
            <Modal.Body>
                <div className="px-2 text-center">
                    <p>Complete your profile to</p>
                    <p><strong>JOIN</strong> the <strong>MOVEMENT</strong></p>
                </div>
                <div className="pt-4 text-center">
                    <button onClick={handleClose} className={`button button-primary ms-4`}>
                        Continue building my profile
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default SavedModal;